export const PASSENGERS_STEP = 'passengers' as const;
export const BOOKING_DETAILS = 'booking-details' as const;
export const CABIN_STEP = 'cabin' as const;
export const INSURANCE_STEP = 'insurance' as const;
export const FLIGHT_STEP = 'flight' as const;
export const PAYMENT_STEP = 'payment' as const;
export const SUMMARY_STEP = 'summary' as const;
export const THANK_YOU_STEP = 'thank-you' as const;

export const API_ERROR_FLAG = 'api-error';
export const EMPTY_RATES = 'no-rates-error';

export const GET_RATES_FEATURE = 'GET_RATES';
export const GET_CABINS_FEATURE = 'GET_CABINS';
export const CREATE_BOOKING_FEATURE = 'CREATE_BOOKING';

export const HOTEL_SERVICE_CHARGE = 'HOTEL_SERVICE_CHARGE';

export const ONLY_DIRECTBOOKING_PRICE_THRESHOLD = 2500;

export const DEFAULT_ADULTS_NUM = 2;
export const DEFAULT_CHILDS_NUM = 0;

export const DEFAULT_MAX_CHILD_YEARS = 16;

export const MIN_SUPPORTED_DOB_DATE = new Date(1900, 0, 1);

export const INSURANCE_FULL_TYPE = 'full' as const;
export const INSURANCE_BASIC_TYPE = 'basic' as const;
export const INSURANCE_NONE_TYPE = 'none' as const;

export const GENDER_MALE = 'm' as const;
export const GENDER_FEMALE = 'f' as const;
export const NOT_AVAILABLE = 'N/A';

export const AIDA_OPERATOR_CODE = 'aid';
export const MSC_OPERATOR_CODE = 'msc';
export const COSTA_OPERATOR_CODE = 'cos';

export const BOOKING_TOKEN_QUERY = 'bt';

export const GENDER_SALUTATION_MAP = {
    // translation keys map
    [GENDER_FEMALE]: 'overviewStep.female',
    [GENDER_MALE]: 'overviewStep.male',
};

export const PASSPORT_DOC_TYPE: string = 'passport';
export const ID_DOC_TYPE: string = 'nationalID';

export const CH_COUNTRY_CODE = 'CH';
export const DE_COUNTRY_CODE = 'DE';
export const AT_COUNTRY_CODE = 'AT';
export const LI_COUNTRY_CODE = 'LI';
export const LU_COUNTRY_CODE = 'LU';

export const BOOKING_QUERY_PARAMS = [
    'numChild',
    'numAdult',
    'cruiseCode',
    'cruiseNid',
    'sailNid',
    'rateCode',
    'cabinNid',
    'includesFlight',
    'selectedAirportCode',
    'isEstimatedPrice',
    'isDreamlinesPackage',
    'isPriceOnRequest',
    'isAllIn',
    'totalPrice',
    'perPersonPrice',
    'currency',
];

export const FLIGHT_CLASS_CODES = [
    {
        code: 'F',
        className: 'firstClass',
    },
    {
        code: 'A',
        className: 'firstClass',
    },
    {
        code: 'J',
        className: 'businessClass',
    },
    {
        code: 'R',
        className: 'businessClass',
    },
    {
        code: 'D',
        className: 'businessClass',
    },
    {
        code: 'W',
        className: 'premiumEconomyClass',
    },
    {
        code: 'P',
        className: 'premiumEconomyClass',
    },
    {
        code: 'Y',
        className: 'economyClass',
    },
    {
        code: 'H',
        className: 'economyClass',
    },
    {
        code: 'K',
        className: 'economyClass',
    },
    {
        code: 'M',
        className: 'economyClass',
    },
    {
        code: 'L',
        className: 'economyClass',
    },
    {
        code: 'G',
        className: 'economyClass',
    },
    {
        code: 'V',
        className: 'economyClass',
    },
    {
        code: 'S',
        className: 'economyClass',
    },
    {
        code: 'N',
        className: 'economyClass',
    },
    {
        code: 'Q',
        className: 'economyClass',
    },
    {
        code: 'O',
        className: 'economyClass',
    },
    {
        code: 'B',
        className: 'businessClass',
    },
];

export const INSURANCE_COUNTRIES = [
    DE_COUNTRY_CODE,
    AT_COUNTRY_CODE,
    LI_COUNTRY_CODE,
    LU_COUNTRY_CODE,
];

export const OPERATOR_CODES = {
    HURTIGRUTEN: 'hur',
} as const;

export const BOOKING_TYPE_DIRECT = 'DIRECT_BOOKING' as const;
export const BOOKING_TYPE_INDIRECT = 'INDIRECT_BOOKING' as const;

export const INTERNAL_BOOKING_TYPES_MAP = {
    DIRECT: 'direct',
    NON_BINDING: 'non-binding',
    BINDING: 'binding',
} as const;

export const GUARANTEE_CABIN_DECK = 'guaranteeCabin';

export function getTermsAndConditionsConfig(
    countryCode: string,
    companyNid: number | string,
): [string, string] {
    const normalizedCC = countryCode.toLocaleUpperCase();
    switch (normalizedCC) {
        case 'BR':
            return [
                `https://www.dreamlines.com.br/reserva-do-cruzeiro/agb_company?company=${companyNid}`,
                'https://www.dreamlines.com.br/termos-e-condicoes',
            ];
        case 'IT':
            return [
                `https://www.dreamlines.it/prenotazione-crociera/condizioni-generali-di-contratto?company=${companyNid}`,
                'https://www.dreamlines.it/condizioni-generali-di-contratto',
            ];
        case 'FR':
            return [
                `https://www.dreamlines.fr/reservation-croisiere/termes-et-conditions?company=${companyNid}`,
                'https://www.dreamlines.fr/termes-et-conditions',
            ];
        case 'AU':
            return [
                `https://www.cruiseaway.com.au/terms-and-conditions?company=${companyNid}`,
                'https://www.cruiseaway.com.au/terms-and-conditions',
            ];
        case 'NL':
            return [
                `https://www.dreamlines.nl/boeking-van-een-cruise/algemene-voorwaarden?company=${companyNid}`,
                'https://www.dreamlines.nl/algemene-voorwaarden',
            ];
        case 'DE':
            return [
                `https://www.dreamlines.de/kreuzfahrtanfrage/agb?company=${companyNid}`,
                'https://www.dreamlines.de/agb',
            ];
        default:
            // just DE as default for now
            return [
                `https://www.dreamlines.de/kreuzfahrtanfrage/agb?company=${companyNid}`,
                'https://www.dreamlines.de/agb',
            ];
    }
}

export function getDisclaimerTextConfig(countryCode: string, companyNid: number | string): string {
    const normalizedCC = countryCode.toLocaleUpperCase();
    switch (normalizedCC) {
        case 'DE':
            return `https://dreamlines-de-upload.s3.amazonaws.com/wp-content/travellaw/${companyNid}.pdf`;
        case 'IT':
            return `https://dreamlines-wp-upload.s3.amazonaws.com/wp-content/travellaw/${companyNid}.pdf`;
        case 'FR':
            return `https://dreamlines-fr-upload.s3.amazonaws.com/wp-content/travellaw/${companyNid}.pdf`;
        case 'NL':
            return `https://dreamlines-nl-upload.s3.amazonaws.com/wp-content/travellaw/${companyNid}.pdf`;
        default:
            return `https://dreamlines-de-upload.s3.amazonaws.com/wp-content/travellaw/${companyNid}.pdf`;
    }
}
